<div class="whatsapp-send-log-container">
  <div class="header">
    <div class="header-content">
      <div>
        <h1>WhatsApp Send Log</h1>
        <p>Every marketing message the system has sent, and its delivery status</p>
      </div>
    </div>
  </div>

  <!-- Tabs -->
  <div class="flex flex-wrap gap-2 mb-4">
    <button type="button" (click)="setTab('log')"
      [class.bg-green-600]="activeTab === 'log'" [class.text-white]="activeTab === 'log'"
      [class.bg-gray-100]="activeTab !== 'log'" [class.text-gray-700]="activeTab !== 'log'"
      class="px-3.5 py-1.5 rounded-lg text-sm font-semibold transition-all flex items-center gap-1.5">
      <i class="fas fa-list"></i> Send Log
    </button>
    <button type="button" (click)="setTab('conversions')"
      [class.bg-green-600]="activeTab === 'conversions'" [class.text-white]="activeTab === 'conversions'"
      [class.bg-gray-100]="activeTab !== 'conversions'" [class.text-gray-700]="activeTab !== 'conversions'"
      class="px-3.5 py-1.5 rounded-lg text-sm font-semibold transition-all flex items-center gap-1.5">
      <i class="fas fa-chart-line"></i> Conversions
    </button>
  </div>

  <ng-container *ngIf="activeTab === 'log'">
  <!-- Filter Section -->
  <div class="filter-section">
    <div class="filter-header">
      <h3><i class="fas fa-filter"></i> Filter</h3>
    </div>

    <div class="filter-form">
      <div class="filter-row">
        <div class="filter-group">
          <label for="campaignFilter">Campaign</label>
          <select
            id="campaignFilter"
            [(ngModel)]="selectedCampaignKey"
            name="campaignFilter"
            class="filter-select"
            (ngModelChange)="onCampaignChange()">
            <option *ngFor="let campaign of campaignOptions" [value]="campaign.key">
              {{ campaign.label }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="statusFilter">Status</label>
          <select
            id="statusFilter"
            [(ngModel)]="statusFilter"
            name="statusFilter"
            class="filter-select"
            (ngModelChange)="onStatusFilterChange()">
            <option value="">All</option>
            <option value="Sent">Sent</option>
            <option value="Failed">Failed</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- Error Message -->
  <div class="error-message" *ngIf="errorMessage">
    <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
  </div>

  <!-- Loading State -->
  <div class="loading" *ngIf="loading && !response">
    <p><i class="fas fa-spinner fa-spin"></i> Loading send log...</p>
  </div>

  <!-- Send Log Table -->
  <div class="table-container" *ngIf="response">
    <div class="pagination-summary">
      <p>{{ response.totalCount || 0 }} log entr{{ (response.totalCount || 0) === 1 ? 'y' : 'ies' }}</p>
    </div>

    <table class="leads-table">
      <thead>
        <tr>
          <th class="col-phone">Phone Number</th>
          <th class="col-campaign">Campaign</th>
          <th class="col-status">Status</th>
          <th class="col-updated">Sent At</th>
          <th class="col-template">Template</th>
          <th class="col-error">Error</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let entry of response.items || []" class="lead-row">
          <td class="col-phone">{{ entry.phoneNumber }}</td>
          <td class="col-campaign">{{ campaignLabel(entry.campaignId) }}</td>
          <td class="col-status">
            <span [class]="entry.status === 'Sent' ? 'status-badge status-active' : 'status-badge status-rejected'">
              {{ entry.status }}
            </span>
          </td>
          <td class="col-updated">{{ entry.sentAt | date:'short' }}</td>
          <td class="col-template">{{ entry.templateName }}</td>
          <td class="col-error">
            <span *ngIf="entry.errorMessage" class="error-text">{{ entry.errorMessage }}</span>
            <span *ngIf="!entry.errorMessage" class="no-data">&mdash;</span>
          </td>
        </tr>
        <tr *ngIf="!response.items || response.items.length === 0">
          <td colspan="6" class="no-leads">
            <p>No send log entries found{{ statusFilter ? ' for status ' + statusFilter : '' }}.</p>
          </td>
        </tr>
      </tbody>
    </table>

    <app-pagination
      *ngIf="response.items && response.items.length > 0"
      [page]="currentPage"
      [totalPages]="totalPages"
      [pageSize]="pageSize"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)">
    </app-pagination>
  </div>
  </ng-container>

  <!-- Conversions tab: did the people we messaged go on to sign up / book a pickup? -->
  <ng-container *ngIf="activeTab === 'conversions'">
    <div class="bg-white rounded-lg border border-gray-200 p-4 mb-6">
      <p class="text-xs text-gray-500 mb-3">
        Filter by the date the message was <strong>sent</strong>. A signup or booking counts if it happened after that person's message.
      </p>
      <div class="flex flex-wrap items-end gap-4">
        <div>
          <label class="block text-xs font-semibold text-gray-500 uppercase mb-1">Sent from</label>
          <app-date-input [(ngModel)]="outreachFromDate"></app-date-input>
        </div>
        <div>
          <label class="block text-xs font-semibold text-gray-500 uppercase mb-1">Sent to</label>
          <app-date-input [(ngModel)]="outreachToDate"></app-date-input>
        </div>
        <div class="flex gap-2">
          <button type="button" (click)="applyOutreachFilters()"
            class="bg-green-600 hover:bg-green-700 text-white text-sm font-semibold px-4 py-2 rounded-md">
            <i class="fas fa-search mr-1"></i> Apply
          </button>
          <button type="button" (click)="clearOutreachFilters()"
            class="bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm font-semibold px-4 py-2 rounded-md">
            <i class="fas fa-times mr-1"></i> Clear
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="outreachError" class="bg-red-50 text-red-700 border border-red-200 rounded-md px-4 py-3 mb-4 text-sm">
      <i class="fas fa-exclamation-circle mr-1"></i> {{ outreachError }}
    </div>

    <div *ngIf="outreachLoading" class="text-center text-gray-500 py-10">
      <i class="fas fa-spinner fa-spin mr-1"></i> Loading conversions...
    </div>

    <div *ngIf="!outreachLoading && !outreachError && outreach" class="bg-white rounded-lg border border-gray-200 overflow-x-auto">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-50 border-b border-gray-200">
          <tr>
            <th class="px-4 py-3 text-left font-semibold text-gray-600">Campaign</th>
            <th class="px-4 py-3 text-right font-semibold text-gray-600">Messages Sent</th>
            <th class="px-4 py-3 text-right font-semibold text-gray-600">People Messaged</th>
            <th class="px-4 py-3 text-right font-semibold text-gray-600">Signed Up</th>
            <th class="px-4 py-3 text-right font-semibold text-gray-600">Pickup Booked</th>
            <th class="px-4 py-3 text-right font-semibold text-gray-600">Signed Up or Booked</th>
            <th class="px-4 py-3 text-right font-semibold text-gray-600">Conversion %</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of outreach.campaigns" class="border-b border-gray-100 hover:bg-gray-50">
            <td class="px-4 py-3 font-medium text-gray-900">{{ outreachLabel(row.campaign) }}</td>
            <td class="px-4 py-3 text-right">{{ row.messagesSent }}</td>
            <td class="px-4 py-3 text-right">{{ row.uniqueRecipients }}</td>
            <td class="px-4 py-3 text-right">{{ row.signedUp }}</td>
            <td class="px-4 py-3 text-right">{{ row.pickupsBooked }}</td>
            <td class="px-4 py-3 text-right">{{ row.signedUpOrBooked }}</td>
            <td class="px-4 py-3 text-right font-semibold">{{ row.conversionPercentage | number:'1.0-2' }}%</td>
          </tr>
          <tr *ngIf="outreach.campaigns.length === 0">
            <td colspan="7" class="px-4 py-10 text-center text-gray-400">No messages were sent in the selected date range.</td>
          </tr>
          <tr *ngIf="outreach.campaigns.length > 0" class="bg-gray-50 border-t-2 border-gray-200 font-semibold">
            <td class="px-4 py-3 text-gray-900">{{ outreachLabel(outreach.total.campaign) }}</td>
            <td class="px-4 py-3 text-right">{{ outreach.total.messagesSent }}</td>
            <td class="px-4 py-3 text-right">{{ outreach.total.uniqueRecipients }}</td>
            <td class="px-4 py-3 text-right">{{ outreach.total.signedUp }}</td>
            <td class="px-4 py-3 text-right">{{ outreach.total.pickupsBooked }}</td>
            <td class="px-4 py-3 text-right">{{ outreach.total.signedUpOrBooked }}</td>
            <td class="px-4 py-3 text-right">{{ outreach.total.conversionPercentage | number:'1.0-2' }}%</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p *ngIf="!outreachLoading && outreach && outreach.campaigns.length > 0" class="text-xs text-gray-500 mt-3">
      Counts signups and bookings made after each person's message — not proof the message caused them. Automatic
      recurring-schedule appointments are not counted as bookings. "All campaigns" counts each person once.
    </p>
  </ng-container>
</div>
